import { render, staticRenderFns } from "./WebPaySucceed.vue?vue&type=template&id=21500de6&scoped=true&"
import script from "./WebPaySucceed.vue?vue&type=script&lang=js&"
export * from "./WebPaySucceed.vue?vue&type=script&lang=js&"
import style0 from "./WebPaySucceed.vue?vue&type=style&index=0&id=21500de6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21500de6",
  null
  
)

export default component.exports